/* Pishuw — Custom Video Slider
   Lazy-loads each video (source set only on tap), pauses others when one plays,
   updates the scroll-progress bar. Loaded with defer, so the DOM is ready. */
(function () {
  function initSlider(slider) {
    slider.querySelectorAll('.dc-vslide__play').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slide = btn.closest('.dc-vslide');
        var video = slide.querySelector('.dc-vslide__video');
        var source = video.querySelector('source');

        // pause any other playing video in this slider + restore its play button
        slider.querySelectorAll('.dc-vslide__video').forEach(function (v) {
          if (v !== video) {
            v.pause();
            var b = v.closest('.dc-vslide').querySelector('.dc-vslide__play');
            if (b) b.style.display = '';
          }
        });

        if (!source.src) {
          source.src = source.getAttribute('data-src');
          video.load();
        }
        video.hidden = false;
        video.muted = false;
        video.play();
        btn.style.display = 'none';
      });
    });

    var fill = slider.parentElement.querySelector('.dc-vslider__bar-fill');
    if (fill) {
      slider.addEventListener('scroll', function () {
        var max = slider.scrollWidth - slider.clientWidth;
        var p = max > 0 ? slider.scrollLeft / max : 0;
        fill.style.width = Math.max(Math.min(p, 1) * 100, 10) + '%';
      }, { passive: true });
    }
  }

  function init() {
    document.querySelectorAll('.dc-vslider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
